"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gérer l'intéractivité entre le bouton menu et le contenant des liens de
 * navigation.
 *
 * @export
 * @class Menu
 */
class Menu {
    menu;
    navItems;
    isOuvert = false;
    /**
     * Créer une instance de Menu.
     *
     * @param {HTMLDivElement} menu Le bouton menu.
     * @param {HTMLDivElement} navItems Le contenant des liens de navigation.
     * @memberof Menu
     */
    constructor(menu, navItems) {
        this.menu = menu;
        this.navItems = navItems;
        this.ajouterListeners();
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof Menu
     */
    ajouterListeners() {
        this.menu.addEventListener("click", () => { this.gererClickBoutonMenu(); });
        window.addEventListener("resize", () => { this.gererWindowResize(); });
    }
    /**
     * Gérer un click sur le bouton menu.
     *
     * @private
     * @memberof Menu
     */
    gererClickBoutonMenu() {
        if (this.isOuvert) {
            this.navItems.style.display = 'none';
            this.menu.innerHTML = 'menu';
        }
        else {
            this.navItems.style.display = 'block';
            this.menu.innerHTML = 'close';
        }
        this.menu.classList.toggle("nav__menu--ouvert");
        this.isOuvert = !this.isOuvert;
    }
    /**
     * Gérer un changement de taille de fenêtre.
     *
     * @private
     * @memberof Menu
     */
    gererWindowResize() {
        if (window.innerWidth >= 1024) {
            this.navItems.style.display = 'block';
        }
        else {
            this.navItems.style.display = this.isOuvert ? 'block' : 'none';
        }
    }
}
exports.default = Menu;
